import {AfterViewInit, Component, ElementRef, EventEmitter,
  Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';

@Component({
  selector: 'ngx-form-text',
  templateUrl: './form-text.component.html',
  styleUrls: ['./form-text.component.scss'],
})
export class FormTextComponent implements OnChanges, AfterViewInit {
  @Input() title: string;
  @Input() value: string;
  @Input() disabled: boolean = false;
  @Input() multiline: number = null;
  @Input() maxChars: number = null;
  @Input() styles = {};
  @Input() noTitle = false;
  @Input() placeholder = null;
  @Output() valueChange: EventEmitter<string>;
  @Output() keyUp: EventEmitter<KeyboardEvent>;
  @Output() focus: EventEmitter<any> = new EventEmitter<any>();
  @Output() focusLost: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('formfield') formFieldRef: ElementRef;

  constructor() {
    this.valueChange = new EventEmitter<string>();
    this.keyUp = new EventEmitter<KeyboardEvent>();
  }

  ngAfterViewInit(): void {
    if (this.formFieldRef && this.multiline) {
      this.formFieldRef.nativeElement.innerText = this.value || '';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.value?.currentValue && typeof changes.value.currentValue === 'string') {
      changes.value.currentValue = this.multiline 
        ? changes.value.currentValue?.replace(/↵/, '\n') 
        : changes.value.currentValue?.replace(/↵/, ' ');
    }
    if (changes && changes.value && this.multiline && this.formFieldRef
      && this.formFieldRef.nativeElement.innerText !== changes.value.currentValue) {
      this.formFieldRef.nativeElement.innerText = changes.value.currentValue || '';
    }
  }

  updateValue(event: string) {
    this.valueChange.emit(event);
  }

  onKey(event: KeyboardEvent) {
    if (this.multiline && this.formFieldRef) {
      this.value = this.formFieldRef.nativeElement.innerText;
      this.valueChange.emit(this.value);
    }
    // console.log('this.value', `>>${this.value}<<`)
    this.keyUp.emit(event);
  }

  onKeydown(event: KeyboardEvent) {
    // console.log('keydown', event.key, event.key.length, this.maxChars, this.formFieldRef);
    if (this.maxChars && this.formFieldRef?.nativeElement?.innerText?.length > this.maxChars) {
      if (event.key.length === 1) event.preventDefault();
    }
    if (event.shiftKey && event.key === 'Enter') {
      event.preventDefault();
      window.document.execCommand('insertText', false, '↵');
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    // console.log('onPaste', this.formFieldRef.nativeElement.innerText.length);
    // if (this.maxChars) pastedText = pastedText.substring(0, this.maxChars - this.value.length < 0 ? 0 : this.maxChars - this.value.length);

    if (this.maxChars && this.value.length + pastedText.length > this.maxChars) {
      pastedText = pastedText.substring(0, this.maxChars - this.value.length);
    }

    window.document.execCommand('insertText', false, pastedText);
    // this.value = this.value + pastedText;
    this.updateValue(this.value);
  
    // console.log('onPaste2', this.formFieldRef.nativeElement.innerText.length);

    this.updateValue(this.value);

    // console.log('pasted', pastedText, this.value);
  }

  getMinHeight() {
    return this.multiline > 1 ? (this.multiline * 22)+'px' : '28px';
  }

  getStyles(styles = {}) {
    return ({ ...styles, ...this.styles })
  }

}
